module.exports = __webpack_public_path__ + "static/media/BrixSans-Light.1737d089.woff";